<template>
  <TarjetaDatos titulo="Datos Bancarios">
    <Campo2L :valor="poliza.titular" etiqueta="Titular" />
    <Campo2L :valor="poliza.iban" etiqueta="IBAN" />
    <Campo2L :valor="poliza.entidad" etiqueta="Entidad" />
    <Campo2L :valor="poliza.oficina" etiqueta="Oficina" />
  </TarjetaDatos>
</template>

<script>
export default {
  props: {
    poliza: {
      type: Object,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped></style>
